<mat-toolbar color="primary">
  <button mat-icon-button (click)="mainMenu.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <span>MONITOR</span>
  <span class="example-spacer"></span>
  <span fxHide.lt-sm="true">{{USERNAME}}</span>
  <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon" (click)="vermanual()">
    <mat-icon>help</mat-icon>
  </button>
  <button
    [swal]="{ title: '¿Cerrar sesión?', showDenyButton: true, denyButtonText: 'No', showConfirmButton: true, confirmButtonText: 'Si'}"
    (confirm)="cerrarSesion()" mat-icon-button class="example-icon" matTooltip="Salir">
    <mat-icon>logout</mat-icon>    
  </button>
 
</mat-toolbar>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #mainMenu mode="push" class="sidenav">
    <!-- inicio menu -->
    <mat-accordion>

      <mat-expansion-panel class="mepanel" hideToggle>
        <mat-expansion-panel-header [routerLink]="'/index'" (click)="mainMenu.close()">
          <mat-panel-title>
            <mat-icon>home</mat-icon> INICIO
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <mat-expansion-panel class="mepanel" *ngFor="let parent of parent_menu" [hideToggle]="!hasChildren(parent)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>{{parent.ICON}}</mat-icon> {{parent.PARENT}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="hasChildren(parent)">
          <mat-nav-list>
            <ng-container *ngFor="let child of children_menu">
              <mat-list-item [routerLink]="'/'+child.URL" *ngIf="child.POS == parent.ID_PARENT"
                (click)="mainMenu.close()">
                <mat-icon>{{child.ICONO}}</mat-icon> {{child.MENU}}
              </mat-list-item>
            </ng-container>
          </mat-nav-list>
        </ng-container>
      </mat-expansion-panel>

    </mat-accordion>
    <!-- fin menu -->
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>